function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#575D7C",
  d: "M21.6 0H2.4C1.074 0 0 1.063 0 2.375v14.25C0 17.937 1.074 19 2.4 19h19.2c1.326 0 2.4-1.063 2.4-2.375V2.375C24 1.063 22.926 0 21.6 0zm-12 4.75c.662 0 1.2.532 1.2 1.188 0 .655-.538 1.187-1.2 1.187-.662 0-1.2-.532-1.2-1.188 0-.655.538-1.187 1.2-1.187zm9.6 10.688H4.826c-.499 0-.78-.57-.472-.959l2.988-3.802c.235-.3.69-.307.934-.014l2.524 3.005 3.718-4.74c.242-.31.716-.306.954.008l4.208 5.552c.296.391.014.95-.48.95z"
});

var SvgImage = function SvgImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image.c62e0a67.svg";
export { ForwardRef as ReactComponent };